import EntityBaseRepository from '@/api/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export interface ApiResult<T> {
    ok: boolean;
    status: number;
    message?: string;
    data: T | null;
}

export default class MaintenanceListFormRepository extends EntityBaseRepository {

    public getFormByActuatorTypeAndFormType(actuatorTypeId: string, formType: string): Promise<AxiosResponse> {
        return this.axiosClient.get(`/maintenanceListForm/actuatorType/${actuatorTypeId}/formType/${formType}`);
    }

    public async getFormsByActuatorName(actuatorName: string): Promise<ApiResult<any[]>> {
        try {
            const response: AxiosResponse = await this.axiosClient.get(`/maintenanceListForm/actuatorName/${actuatorName}`);

            return {
                ok: true,
                status: response.status,
                data: response.data,
            };
        } catch (error) {
            const err = error as any;

            const status =
                err?.response?.status ??
                err?.status ??
                (err?.message?.includes('404') ? 404 : 0);
            const message =
                err?.response?.data?.message ||
                err?.message ||
                'Unbekannter Fehler beim Laden der Formulare';

            // Wichtig: Fehler gefahrlos zurückgeben, nicht werfen
            return {
                ok: false,
                status,
                message,
                data: null,
            };
        }

    }
}
